import { GlassCard } from "@kj/design-system";

export default function KYCQueuePage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">KYC Queue</h1>
      <p className="text-sm text-fg-muted">
        사용자가 제출한 신분증 + 셀피 매칭 결과. 승인/반려를 통해 파란 체크 배지를 발급.
      </p>
      <GlassCard padding="lg" radius="2xl">
        <div className="text-sm text-fg-muted text-center py-10">
          대기열 비어 있음. 원본 이미지는 72시간 내 자동 파기되며 해시만 보관.
        </div>
      </GlassCard>
    </div>
  );
}
